/** Logical canvas (16:9 scene overlay). */
export const THE_GAMBLE_LOGICAL_WIDTH = 1920;
export const THE_GAMBLE_LOGICAL_HEIGHT = 1080;

export const THE_GAMBLE_BACKGROUND_SRC = '/minigames/blackjack.jpg';

/** Server `minigames.theGamble.targetScore` */
export const THE_GAMBLE_TARGET_SCORE = 15;
/** Server `minigames.theGamble.winPickValue` */
export const THE_GAMBLE_WIN_PICK_VALUE = 1;
/** Server `minigames.theGamble.lossPickValue` */
export const THE_GAMBLE_LOSS_PICK_VALUE = 0;
/** Server `minigames.theGamble.lossDarknessIncrementPercent` */
export const THE_GAMBLE_LOSS_DARKNESS_INCREMENT_PERCENT = 10;

/**
 * Player order cards on the blackjack desk (logical 1920×1080).
 * First card anchor on the desk (logical 1920×1080); tune X/Y here.
 */
export const THE_GAMBLE_PLAYER_DESK_FIRST_CARD_X = 460;
export const THE_GAMBLE_PLAYER_DESK_FIRST_CARD_Y = 620;
/** Horizontal spacing between cards dealt on the desk. */
export const THE_GAMBLE_PLAYER_DESK_CARD_STEP_X = 98;

/**
 * @param {number} logicalX
 * @param {number} logicalY
 * @returns {{ left: string, top: string }}
 */
export function theGambleLogicalToPercentPosition(logicalX, logicalY) {
  if (!Number.isFinite(logicalX) || !Number.isFinite(logicalY)) {
    throw new Error(`theGambleLogicalToPercentPosition: invalid coords (${logicalX}, ${logicalY})`);
  }
  return {
    left: `${(logicalX / THE_GAMBLE_LOGICAL_WIDTH) * 100}%`,
    top: `${(logicalY / THE_GAMBLE_LOGICAL_HEIGHT) * 100}%`,
  };
}

/**
 * @param {number} handIndex 0-based position in the player's hand on the desk
 * @returns {{ left: string, top: string }}
 */
export function theGamblePlayerDeskCardPercentPosition(handIndex) {
  if (!Number.isInteger(handIndex) || handIndex < 0) {
    throw new Error(`theGamblePlayerDeskCardPercentPosition: invalid handIndex (${String(handIndex)})`);
  }
  const x = THE_GAMBLE_PLAYER_DESK_FIRST_CARD_X + handIndex * THE_GAMBLE_PLAYER_DESK_CARD_STEP_X;
  const y = THE_GAMBLE_PLAYER_DESK_FIRST_CARD_Y;
  return theGambleLogicalToPercentPosition(x, y);
}
